"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AvatarPopup_component_exports = {};
__export(AvatarPopup_component_exports, {
  AvatarPopup: () => AvatarPopup,
  default: () => AvatarPopup_component_default
});
module.exports = __toCommonJS(AvatarPopup_component_exports);
var import_react = __toESM(require("react"));
var import_Tooltip = require("../../atoms/Tooltip/Tooltip.component");
var import_Button = require("../../atoms/Button/Button.component");
var import_AvatarCard = require("../AvatarCard/AvatarCard.component");
var import_GlobalHeader = require("../../organisms/GlobalHeader/GlobalHeader.constants");
var import_useOnClickOutside = require("../../../utils/useOnClickOutside/useOnClickOutside.hook");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_Helpers = require("../../../utils/Helpers");
var import_roles = require("../../../utils/roles");
var import_useBreakpoints = require("../../../utils/useBreakpoints/useBreakpoints.hook");
var import_react_i18next = require("react-i18next");
var import_AvatarPopup = require("./AvatarPopup.styled");
var import_GlobalHeader2 = require("../../organisms/contexts/GlobalHeader/GlobalHeader.controller");
var _excluded = ["darkMode", "currentRole", "availableRoles", "appElement", "mobileView", "withKebabMenu", "avatarButtonVariant", "avatarSize", "avatarFontSize", "showLogoutButton", "studentVariant", "CustomLogoutActionElement", "headerHeight"];
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var AvatarPopup = function AvatarPopup2(_ref) {
  var _props$closeAvatarBut, _props$closeAvatarBut2;
  var _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$currentRole = _ref.currentRole, currentRole = _ref$currentRole === void 0 ? import_roles.NOT_ROLE_SELECTED : _ref$currentRole, _ref$availableRoles = _ref.availableRoles, availableRoles = _ref$availableRoles === void 0 ? [] : _ref$availableRoles, _ref$appElement = _ref.appElement, appElement = _ref$appElement === void 0 ? "head" : _ref$appElement, _ref$mobileView = _ref.mobileView, mobileView = _ref$mobileView === void 0 ? false : _ref$mobileView, _ref$withKebabMenu = _ref.withKebabMenu, withKebabMenu = _ref$withKebabMenu === void 0 ? true : _ref$withKebabMenu, avatarButtonVariant = _ref.avatarButtonVariant, _ref$avatarSize = _ref.avatarSize, avatarSize = _ref$avatarSize === void 0 ? 40 : _ref$avatarSize, _ref$avatarFontSize = _ref.avatarFontSize, avatarFontSize = _ref$avatarFontSize === void 0 ? "medium" : _ref$avatarFontSize, _ref$showLogoutButton = _ref.showLogoutButton, showLogoutButton = _ref$showLogoutButton === void 0 ? {
    show: true,
    customStyles: "",
    customIcon: "go-to"
  } : _ref$showLogoutButton, _ref$studentVariant = _ref.studentVariant, studentVariant = _ref$studentVariant === void 0 ? false : _ref$studentVariant, _ref$CustomLogoutActi = _ref.CustomLogoutActionElement, CustomLogoutActionElement = _ref$CustomLogoutActi === void 0 ? false : _ref$CustomLogoutActi, _ref$headerHeight = _ref.headerHeight, headerHeight = _ref$headerHeight === void 0 ? 0 : _ref$headerHeight, props = _objectWithoutProperties(_ref, _excluded);
  var avatarButtonRef = (0, import_react.useRef)(null);
  var cardAvatarRef = (0, import_react.useRef)(null);
  var _useState = (0, import_react.useState)(false), _useState2 = _slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
  var _useState3 = (0, import_react.useState)(0), _useState4 = _slicedToArray(_useState3, 2), itemPosition = _useState4[0], setItemPosition = _useState4[1];
  var _useState5 = (0, import_react.useState)([]), _useState6 = _slicedToArray(_useState5, 2), avatarItems = _useState6[0], setAvatarItems = _useState6[1];
  var _useState7 = (0, import_react.useState)(0), _useState8 = _slicedToArray(_useState7, 2), scrollHeightPopup = _useState8[0], setScrollHeightPopup = _useState8[1];
  var _useState9 = (0, import_react.useState)(0), _useState10 = _slicedToArray(_useState9, 2), windowHeight = _useState10[0], setWindowHeight = _useState10[1];
  var _useState11 = (0, import_react.useState)(null), _useState12 = _slicedToArray(_useState11, 2), windowScrollY = _useState12[0], setWindowScrollY = _useState12[1];
  var _useState13 = (0, import_react.useState)(null), _useState14 = _slicedToArray(_useState13, 2), popupType = _useState14[0], setPopupType = _useState14[1];
  var _useState15 = (0, import_react.useState)(null), _useState16 = _slicedToArray(_useState15, 2), avatarContainerHeight = _useState16[0], setAvatarContainerHeight = _useState16[1];
  var breakpoints = (0, import_useBreakpoints.useBreakpoints)();
  var globalHeaderPopupStateConsumer = (0, import_GlobalHeader2.useGlobalHeaderPopupState)();
  var showLogoutButtonMemo = (0, import_react.useMemo)(function() {
    return showLogoutButton;
  }, []);
  var username = "".concat(props.user.firstName, " ").concat(props.user.lastName);
  var avatarCadId = "avatar-card-btn";
  var avatarContainerRef = (0, import_react.useRef)(null);
  var is400percent = breakpoints.isSm || breakpoints.isXs;
  var isKebabOrStudent = popupType === "kebab" || popupType === "student";
  (0, import_react.useEffect)(function() {
    switch (true) {
      case studentVariant:
        setPopupType("student");
        break;
      case withKebabMenu:
        setPopupType("kebab");
        break;
      default:
        setPopupType("default");
        break;
    }
  }, [withKebabMenu, studentVariant]);
  (0, import_react.useEffect)(function() {
    if (cardAvatarRef.current) {
      var avatarFocusItems = Array.prototype.slice.call((0, import_Helpers.getFocusableEls)(cardAvatarRef.current));
      var dataTestId = "Switch roles mobile";
      var filteredAvatarFocusItems = avatarFocusItems.filter(function(element) {
        return element.dataset.testid !== dataTestId;
      });
      setAvatarItems(filteredAvatarFocusItems);
      if (is400percent && isOpen && avatarFocusItems.length)
        avatarFocusItems[0].focus();
    }
  }, [showLogoutButtonMemo, isOpen]);
  (0, import_react.useEffect)(function() {
    if (!headerHeight && avatarContainerRef.current) {
      setAvatarContainerHeight(avatarContainerRef.current.clientHeight);
    } else {
      setAvatarContainerHeight(headerHeight);
    }
  }, [headerHeight, avatarContainerRef.current]);
  var setAvatarPopupScrollOnSticky = function setAvatarPopupScrollOnSticky2() {
    var _cardAvatarRef$curren;
    if (windowHeight < avatarContainerHeight + (cardAvatarRef === null || cardAvatarRef === void 0 || (_cardAvatarRef$curren = cardAvatarRef.current) === null || _cardAvatarRef$curren === void 0 ? void 0 : _cardAvatarRef$curren.clientHeight)) {
      setScrollHeightPopup(windowHeight - avatarContainerHeight);
    } else {
      setScrollHeightPopup(0);
    }
  };
  (0, import_react.useEffect)(function() {
    if (isOpen) {
      setAvatarPopupScrollOnSticky();
    }
  }, [isOpen, windowHeight, avatarContainerHeight]);
  (0, import_react.useEffect)(function() {
    var handleResize = function handleResize2() {
      return setWindowHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return function() {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  var onAvatarClick = function onAvatarClick2() {
    var roleSwitchModalIsOpen = document.getElementById("role-switch-modal-content");
    setItemPosition(0);
    if (!roleSwitchModalIsOpen)
      setIsOpen(function(prevState) {
        return !prevState;
      });
    if (globalHeaderPopupStateConsumer && !isOpen) {
      globalHeaderPopupStateConsumer.setGlobalHeaderActivePopup(import_GlobalHeader.popupsIds.avatarPopup);
    }
  };
  var setFocusOnIcon = function setFocusOnIcon2() {
    avatarButtonRef.current.focus();
  };
  (0, import_useOnClickOutside.useOnClickOutside)(cardAvatarRef, function(e) {
    var popup;
    var currentAvatarButton = avatarButtonRef.current;
    if (is400percent && isKebabOrStudent) {
      var _cardAvatarRef$curren2;
      popup = (_cardAvatarRef$curren2 = cardAvatarRef.current) === null || _cardAvatarRef$curren2 === void 0 || (_cardAvatarRef$curren2 = _cardAvatarRef$curren2.parentElement) === null || _cardAvatarRef$curren2 === void 0 ? void 0 : _cardAvatarRef$curren2.parentElement;
    } else {
      var _cardAvatarRef$curren3;
      popup = (_cardAvatarRef$curren3 = cardAvatarRef.current) === null || _cardAvatarRef$curren3 === void 0 ? void 0 : _cardAvatarRef$curren3.parentElement;
    }
    var isClickedOverAvatar = currentAvatarButton === e.target.parentElement || currentAvatarButton.firstChild === e.target.parentElement || currentAvatarButton === e.srcElement || e.target === popup;
    var roleSwitchModalIsOpen = document.getElementById("role-switch-modal-content");
    var roleSwitchModalIsLoading = document.getElementById("role-switch-modal-loading-content");
    if (roleSwitchModalIsOpen || roleSwitchModalIsLoading || isClickedOverAvatar) {
      return;
    }
    setIsOpen(false);
    if (isOpen) {
      setItemPosition(0);
    }
  });
  if (globalHeaderPopupStateConsumer) {
    (0, import_react.useEffect)(function() {
      if (globalHeaderPopupStateConsumer.globalHeaderActivePopup !== import_GlobalHeader.popupsIds.avatarPopup) {
        setIsOpen(false);
      }
    }, [globalHeaderPopupStateConsumer.globalHeaderActivePopup]);
  }
  var KEYCODE_TAB = 9;
  var handleLastTab = function handleLastTab2(e) {
    if (e.keyCode === KEYCODE_TAB) {
      e.preventDefault();
      if (!e.shiftKey)
        avatarItems[0].focus();
      else
        avatarItems[avatarItems.length - 2].focus();
    }
  };
  var handleFirstTab = function handleFirstTab2(e) {
    if (e.keyCode === KEYCODE_TAB && e.shiftKey) {
      e.preventDefault();
      avatarItems[avatarItems.length - 1].focus();
    }
  };
  (0, import_react.useEffect)(function() {
    if (avatarItems.length !== 0) {
      var lastEl = avatarItems[avatarItems.length - 1];
      var firstEl = avatarItems[0];
      if (lastEl) {
        lastEl.addEventListener("keydown", handleLastTab);
      }
      if (firstEl) {
        firstEl.addEventListener("keydown", handleFirstTab);
      }
    }
  }, [avatarItems]);
  (0, import_useOnKeydown.useOnKeydown)(cardAvatarRef, function(keyList, event) {
    var Escape = keyList.Escape, ArrowDown = keyList.ArrowDown, ArrowUp = keyList.ArrowUp;
    var roleSwitchModalIsLoading = document.getElementById("role-switch-modal-loading-content");
    var tooltipElement = cardAvatarRef.current.querySelector('[role="tooltip"]');
    if (Escape && roleSwitchModalIsLoading) {
      event.stopPropagation();
    }
    if (Escape && !tooltipElement) {
      event.stopPropagation();
      setIsOpen(false);
      setFocusOnIcon();
    }
    if (ArrowUp) {
      var pos = itemPosition - 1;
      if (itemPosition > 0 && avatarItems[pos]) {
        setItemPosition(pos);
        avatarItems[pos].focus();
      }
      if (pos < 0) {
        avatarItems[avatarItems.length - 1].focus();
        setItemPosition(avatarItems.length - 1);
      }
    }
    if (ArrowDown) {
      var _pos = itemPosition === 0 ? 1 : itemPosition + 1;
      if (itemPosition < avatarItems.length - 1 && avatarItems[_pos]) {
        avatarItems[_pos].focus();
        setItemPosition(_pos);
      }
      if (_pos >= avatarItems.length) {
        setItemPosition(0);
        avatarItems[0].focus();
      }
    }
  });
  var closePopupFocusTrigger = function closePopupFocusTrigger2() {
    if (props.closeAvatarButtonProps && props.closeAvatarButtonProps.onCloseButtonClick) {
      props.closeAvatarButtonProps.onCloseButtonClick();
    }
    setIsOpen(false);
    setFocusOnIcon();
  };
  (0, import_useOnKeydown.useOnKeydown)(avatarButtonRef, function(event) {
    var Tab = event.Tab, Shift = event.Shift, Escape = event.Escape;
    if (Tab && Shift || Escape) {
      setIsOpen(false);
    }
  });
  var changeRoleHandler = function changeRoleHandler2(roleSelected, closeModal) {
    if (props.onChangeRole) {
      props.onChangeRole(roleSelected, function() {
        closeModal();
        setIsOpen(false);
        if (props.closeKebabMenu) {
          props.closeKebabMenu();
        }
      });
    }
  };
  var AvatarCardRender = /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.AvatarCard, {
    appElement,
    availableRoles,
    closeAvatar: closePopupFocusTrigger,
    closeAvatarButtonProps: {
      ariaLabel: (_props$closeAvatarBut = props.closeAvatarButtonProps) === null || _props$closeAvatarBut === void 0 ? void 0 : _props$closeAvatarBut.ariaLabel,
      onCloseButtonClick: (_props$closeAvatarBut2 = props.closeAvatarButtonProps) === null || _props$closeAvatarBut2 === void 0 ? void 0 : _props$closeAvatarBut2.onCloseButtonClick
    },
    currentRole,
    CustomLogoutActionElement,
    endImpersonationButtonText: props.endImpersonationButtonText,
    impersonating: props.impersonating,
    impersonator: props.impersonator,
    mobileView,
    onChangeRole: changeRoleHandler,
    onEndImpersonation: props.onEndImpersonation,
    onLogout: props.onLogout,
    ref: cardAvatarRef,
    showLogoutButton: {
      show: showLogoutButton.show,
      variant: showLogoutButtonMemo.variant ? showLogoutButtonMemo.variant : "primary",
      customStyles: showLogoutButtonMemo.customStyles,
      customIcon: showLogoutButtonMemo.customIcon,
      customLabel: showLogoutButtonMemo.customLabel
    },
    scrollHeightPopup,
    user: props.user,
    withKebabMenu: popupType === "kebab",
    hideAppSelector: props.hideAppSelector,
    appSelector: props.appSelector,
    studentVariant
  });
  (0, import_react.useEffect)(function() {
    var bodyElement;
    if ((0, import_Helpers.hasDocument)() && isKebabOrStudent) {
      bodyElement = document.body;
    }
    if (isOpen) {
      if (isKebabOrStudent) {
        setWindowScrollY(window.scrollY);
        if (bodyElement) {
          bodyElement.style.overflow = "hidden";
        }
      }
    }
    if (!isOpen) {
      if (isKebabOrStudent) {
        if (bodyElement) {
          bodyElement.style.overflow = "";
        }
        if (windowScrollY) {
          window.scroll(0, windowScrollY);
        }
      }
    }
  }, [isOpen, avatarItems]);
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  return /* @__PURE__ */ import_react.default.createElement(import_AvatarPopup.StyledAvatarPopUpContainer, {
    ref: avatarContainerRef
  }, is400percent && popupType === "kebab" ? /* @__PURE__ */ import_react.default.createElement(import_Button.Button, {
    icon: "more-ver",
    "data-testid": "avatarPopupWithKebabMenuButton",
    "aria-label": t("dp_core_avatarPopup_kebabMenu"),
    iconSize: 26,
    onClick: onAvatarClick,
    darkMode,
    variant: "empty",
    circle: true,
    size: "40px",
    "aria-expanded": isOpen,
    ref: avatarButtonRef
  }) : /* @__PURE__ */ import_react.default.createElement(import_Tooltip.Tooltip, {
    value: username,
    placement: "bottom"
  }, /* @__PURE__ */ import_react.default.createElement(import_AvatarPopup.StyledAvatarButton, {
    id: avatarCadId,
    "aria-expanded": isOpen,
    "aria-label": "".concat(t("dp_core_avatarPopup_button"), ": ").concat(username),
    isSelected: isOpen,
    onClick: onAvatarClick,
    ref: avatarButtonRef,
    type: "button",
    className: "profile-button",
    darkMode,
    "data-testid": "avatar-button"
  }, /* @__PURE__ */ import_react.default.createElement(import_AvatarPopup.StyledAvatar, {
    size: avatarSize,
    user: props.user,
    darkMode,
    variant: avatarButtonVariant,
    fontSize: props.impersonating ? "small" : avatarFontSize,
    impersonating: props.impersonating
  }))), is400percent && isKebabOrStudent ? /* @__PURE__ */ import_react.default.createElement(import_AvatarPopup.StyleAvatarWithKebab, {
    isOpen,
    "data-testid": "avatarCardWithKebab"
  }, AvatarCardRender) : /* @__PURE__ */ import_react.default.createElement(import_AvatarPopup.StyledPopover, {
    isOpen,
    offset: [0, 5],
    placement: "bottom-end",
    referenceElem: avatarButtonRef,
    width: "400px",
    role: "dialog",
    "aria-label": t("dp_core_avatarPopup_userMenu"),
    "aria-hidden": !isOpen,
    withAriaControls: false,
    tabTrapFocus: true
  }, AvatarCardRender));
};
AvatarPopup.displayName = "AvatarPopup";
var AvatarPopup_component_default = AvatarPopup;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AvatarPopup
});
//# sourceMappingURL=AvatarPopup.component.js.map